import {MerchantLinkStyle, PanelLink} from "../paywall/panel-elements/Primitives";
import {Messages} from "../Messages";
import {styleRuleInherit} from "../../stem-core/src/decorators/Style";
import {registerStyle} from "../../stem-core/src/ui/style/Theme";
import {isFacebookBrowser} from "../Utils";
import {BLINK_PAY_URL} from "../Constants";
import {userService} from "../../client/connection/Services";

class MerchantUserResourcesAccessLinkStyle extends MerchantLinkStyle {
    @styleRuleInherit
    link = {
        display: "block",
        marginTop: 12,
    };
}

@registerStyle(MerchantUserResourcesAccessLinkStyle)
export class MerchantUserResourcesAccessLink extends PanelLink {
    static shouldSanitizeOptions = false;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            hasAvailableResources: false,
            extraResourcesCount: null,
            href: BLINK_PAY_URL + "/get-cookie?email=" + encodeURIComponent(userService.getUserEmail()),
            newTab: true,
            message: null,
            rel: "opener",
        };
    }

    render() {
        if (isFacebookBrowser()) { // TODO: Maybe support these later.
            return null;
        }
        const {extraResourcesCount, message} = this.options;
        if (message) {
            return message;
        }
        return Messages.merchantUserResourcesAccessLink(extraResourcesCount);
    }
}
